module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h5>'+
((__t=( title ))==null?'':__t)+
'</h5><p>'+
((__t=( message ))==null?'':__t)+
' </p> ';
 if(hasCloseButton){
__p+=' <fieldset class="button-wrap"><button data-click="error-close">'+
((__t=( i18n.tc("SubscriptionPanel", "Close") ))==null?'':__t)+
'</button></fieldset> ';
 } 
__p+='';
}
return __p;
};
